import { useEffect, useCallback } from 'react';
import { postApi } from '@/util/request.js';
import s from './style.module.scss';
import { useStores } from '../../stores/storeContext';
import { useRouter } from 'next/router';

// Apple Sign in with Apple JS API
// https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js

function AppleLoginButton(props) {
  const isWing = props?.appType === 'wing';
  const isRetrieveData = props?.isRetrieveData;
  const clientId = 'duetapp.ai.webauth';
  const router = useRouter();
  const { rootStore } = useStores();
  const { updateKey } = rootStore;

  useEffect(() => {
    // 加载 Apple JS SDK
    if (!window.AppleID) {
      const script = document.createElement('script');
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.onload = initAppleSignIn;
      document.head.appendChild(script);
    } else {
      initAppleSignIn();
    }
  }, []);

  const initAppleSignIn = useCallback(() => {
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: clientId,
        scope: 'name email',
        redirectURI: `${window.location.origin}${isRetrieveData ? '/retrieve-data' : '/account'}`,
        usePopup: true,
      });
    }
  }, [clientId]);

  const handleAppleSignIn = useCallback(async () => {
    try {
      if (!window.AppleID) {
        console.error('Apple JS SDK not loaded');
        return;
      }

      const response = await window.AppleID.auth.signIn();

      // response 包含 authorization 对象，其中有 id_token 和 code
      const { authorization } = response;

      if (authorization?.id_token) {
        if (isRetrieveData) {
          // 账号删除/数据取回场景
          const res = await postApi(`${window.location.protocol}//${window.location.host}/web/account/support/thirdparty`, {
            grantType: 'apple',
            thirdPartyAccessToken: authorization.id_token,
            authorizationCode: authorization.code,
          });

          if (res.meta?.code === 200) {
            if (res.data?.token) {
              updateKey('token', res.data?.token);
              return router.push('/log-entries/del-account');
            } else if (res.data?.deletedUser) {
              const deletedUser = res.data.deletedUser;
              updateKey('token', '');
              updateKey('deleteTime', deletedUser.deleteTime || res.data?.deleteTime);
              updateKey('deletedUserPhone', deletedUser.mobileNumber || '');
              updateKey('deletedUserEmail', deletedUser.email || '');
              updateKey('loginGrantType', 'apple');
              updateKey('thirdpartyAccessToken', authorization.id_token);
              return router.push('/log-entries/download-info');
            } else {
              return router.push('/log-entries/no-account');
            }
          } else {
            return router.push('/log-entries/no-account');
          }
        } else {
          // 登录/注册场景
          const res = await postApi(`${window.location.protocol}//${window.location.host}/web/account/login`, {
            grantType: 'apple',
            thirdPartyAccessToken: authorization.id_token,
            authorizationCode: authorization.code,
          });

          if (res.meta?.code === 200 && res.data?.token) {
            updateKey('token', res.data?.token);
            return router.push('/log-entries/del-account');
          } else {
            return router.push('/log-entries/no-account');
          }
        }
      }
    } catch (error) {
      console.error('Apple Sign In Error:', error);
      // 用户取消登录或其他错误
    }
  }, [router, updateKey]);

  return (
    <div className={s.appleSignInBtn} onClick={handleAppleSignIn} />
  );
}

export default AppleLoginButton;

